import React, { useState, createContext } from 'react';

export const HsaExpenseFormContext = createContext({
  amount: '',
  merchant: '',
  purchase_date: '',
  description: '',
  receipts: [] as Array<File>,
  setFormInfo: (v: {
    amount: string;
    merchant: string;
    purchase_date: string;
    description: string;
    receipts: Array<File>;
  }) => {},
});

export const HsaExpenseFormContextProvider = ({ children }: $TSFixMe) => {
  const [form_info, setFormInfo] = useState({
    amount: '',
    merchant: '',
    purchase_date: '',
    description: '',
    receipts: [] as Array<File>,
  });

  return (
    <HsaExpenseFormContext.Provider value={{ ...form_info, setFormInfo }}>
      {children}
    </HsaExpenseFormContext.Provider>
  );
};

export default HsaExpenseFormContext;
